import { gql } from "@apollo/client";


export const GET_MATERIAL_LIST = gql`
query getEbookTypes($lId:UUID!) {
  getEbookTypes(libraryid: $lId) {
    nodes {
      typeName
    }
  }
}`;
